import { HttpLink } from 'apollo-angular/http';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';

import { CookieService } from 'ngx-cookie-service';
import { SharedModule } from '../shared/shared.module';
import { NotifyOrConfirmComponent } from './components/notify-or-confirm/notify-or-confirm.component';
import { SessionTimeoutComponent } from './components/session-timeout/session-timeout.component';
import { AuthenticatedGuard } from './guards/authenticated.guard';
import { ForDeveloperGuard } from './guards/for-developer.guard';
import { LoginGuard } from './guards/login.guard';
import { LogoutGuard } from './guards/logout.guard';
import { SessionLoginGuard } from './guards/session-login.guard';
import { SetRegisterGuard } from './guards/set-register.guard';
import { ExternalUrlRedirectResolver } from './resolver/external-url-redirect.resolver';
import { AdditionalOrderInformationTemplateService } from './services/additional-order-information-template.service';
import { AuthService } from './services/auth.service';
import { CompanyService } from './services/company.service';
import { ConfigService } from './services/config.service';
import { ContractorService } from './services/contractor.service';
import { DateFormatService } from './services/dateFormat.service';
import { DongleService } from './services/dongle.service';
import { FileService } from './services/file.service';
import { GeocodeService } from './services/geocoder.service';
import { GraphqlService } from './services/graphql.service';
import { InitService } from './services/init.service';
import { LabLockService } from './services/lab-lock.service';
import { LinkedPartnerService } from './services/linked-partner.service';
import { ListService } from './services/list.service';
import { LocaleService } from './services/locale.service';
import { LoggerService } from './services/logger.service';
import { MenuService } from './services/menu.service';
import { NotifyOrConfirmService } from './services/notify-or-confirm.service';
import { OptionsService } from './services/options.service';
import { OrderService } from './services/order.service';
import { RouterDataService } from './services/router-data.service';
import { SelectivePreloadingStrategyService } from './services/selective-preloading-strategy.service';
import { SessionService } from './services/session.service';
import { StorageService } from './services/storage.service';
import { UserService } from './services/user.service';
import { WindowRefService } from './services/window.service';
import { WorkticketService } from './services/workticket.service';
import { ScrollerService } from './services/scroller.service';
import { TermsAndConditionsModalComponent } from './components/terms-and-conditions-modal/terms-and-conditions-modal.component';
import { FormInputModule } from '../forms/forms.module';
import { MetaInfoService } from './services/meta-info.service';

@NgModule({
	imports: [
		// Modules
		CommonModule,
		NgbModule,
		HttpClientModule,
		SharedModule,
		TranslateModule,
		FormInputModule
	],
	providers: [
		// Angular Core
		HttpLink,

		// Services
		AdditionalOrderInformationTemplateService,
		AuthService,
		CookieService,
		CompanyService,
		ConfigService,
		ContractorService,
		DateFormatService,
		DongleService,
		LinkedPartnerService,
		FileService,
		GeocodeService,
		GraphqlService,
		InitService,
		LabLockService,
		ListService,
		LoggerService,
		MenuService,
		MetaInfoService,
		NotifyOrConfirmService,
		OptionsService,
		OrderService,
		RouterDataService,
		ScrollerService,
		SelectivePreloadingStrategyService,
		SessionService,
		StorageService,
		LocaleService,
		UserService,
		WindowRefService,
		WorkticketService,

		// Guards
		AuthenticatedGuard,
		ForDeveloperGuard,
		LoginGuard,
		LogoutGuard,
		SessionLoginGuard,
		SetRegisterGuard,

		// Resolvers
		ExternalUrlRedirectResolver
	],
	declarations: [
		// Components
		NotifyOrConfirmComponent,
		SessionTimeoutComponent,
		TermsAndConditionsModalComponent
	],
	exports: [
		// Components
		NotifyOrConfirmComponent,
		SessionTimeoutComponent,
		TermsAndConditionsModalComponent
	]
})
export class CoreModule {}
